import { render, staticRenderFns } from "./DaysOfWeekToggler.vue?vue&type=template&id=90daa4e4&"
import script from "./DaysOfWeekToggler.vue?vue&type=script&lang=ts&"
export * from "./DaysOfWeekToggler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VAvatar,VBtn,VBtnToggle})
